import { render } from "./FungiHeader.vue?vue&type=template&id=6470e82b"
import script from "./FungiHeader.vue?vue&type=script&lang=js"
export * from "./FungiHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__